module.exports = __webpack_public_path__ + "static/media/1.09d73956.png";